import React from 'react';
import ScrollView from 'devextreme-react/scroll-view';
import { Header } from '../../components';
import './single-card.scss';

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ title, children, showHeader = true }) => {
  if (showHeader === false) {
    // centered card layout for login/create-account flows
    return (
      <div className={'single-card-centered'}>
        <div className={'dx-card content centered-card'}>
          {title ? (
            <div className={'header'}>
              <div className={'title'}>{title}</div>
            </div>
          ) : null}
          {children}
        </div>
      </div>
    );
  }

  return (
    <div className={'layout-with-header'}>
      {showHeader !== false && <Header title={title} />}
      <div className="content-scroll-wrapper">
        <ScrollView className={'with-footer single-card'} useNative={true} height={'100%'}>
          <div className={'dx-card content'} style={{ width: '100%', boxSizing: 'border-box' }}>
            {children}
          </div>
        </ScrollView>
      </div>
    </div>
  );
};
